export default "__VITE_ASSET__C7vEB8ef__"